import { StepperItem } from '../Page/PageTypes';
import styles from './FormSideStepper.module.scss';
import clsx from 'clsx';

type FormSideStepperProps = {
    stepperConfig: StepperItem[];
    step: number;
    isFormValid: boolean;
    handleStepClick: (stepNumber) => void;
};

const FormSideStepper = (props: FormSideStepperProps) => {
    const handleClick = (stepId: string) => {
        switch (stepId) {
            case 'DEAL_TERMS':
                props.handleStepClick(0);
                break;
            case 'SELECT_INVESTORS':
                props.handleStepClick(1);
                break;
        }
    };
    return (
        <div className={styles.FormStepperWrapper}>
            <div className={styles.StepperContainer}>
                {props.stepperConfig.map((item, index) => {
                    return (
                        <div
                            onClick={() => handleClick(item.stepId)}
                            key={index}
                            className={clsx({
                                [styles.StepperItem]: true,
                                [styles.StepperItemActive]: props.step === index,
                                [styles.StepperItemDisabled]: !props.isFormValid,
                            })}
                        >
                            <div className={styles.StepperText}>
                                {index + 1}. {item.text}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default FormSideStepper;
